<template>
  <div class="head-button">
    <template v-if="showParentBtn">
      <div>
        <div
          class="head-button-first"
          :style="{ marginRight: buttonObj.fullTitle ? '20px' : '0' }"
          @click="handleCreate"
          v-permission="buttonObj.permissionData"
        >
          <span><i class="el-icon-plus"></i></span>
          <span v-if="buttonObj.fullTitle">{{ buttonObj.fullTitle }}</span>
          <span v-else>新建{{ buttonObj.title }}</span>
        </div>
      </div>
      <div class="button-list">
        <template v-for="(item, index) in buttonList">
          <el-button
            v-permission="item.permission"
            :key="'b' + index"
            size="small"
            :type="item.title === '普通建单' ? 'primary' : 'text'"
            :disabled="item.disabled"
            @click="handleOperateParent(item.key)"
          >
            <i :class="item.icon" style="font-size:13px"></i>
            &nbsp;{{ item.title }}
          </el-button>
        </template>
        <div class="head-button-tag" v-if="tagsData">
          <el-tag>
            <div class="tag-text">{{ tagsData }}</div>
            <div>
              <i
                class="el-tag__close el-icon-close"
                @click="handleTagClose"
              ></i>
            </div>
          </el-tag>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        :class="
          selected.length > 0 ? 'head-button-card' : 'head-button-card-disabled'
        "
      >
        <el-row>
          <el-col :span="22">
            <span style="padding-left:23px"
              >已选择 {{ selected.length }} 个计划单</span
            >
            <el-divider direction="vertical"></el-divider>
            <slot name="btn"> </slot>
            <template v-for="(child, index) in childrenBtnList">
              <el-button
                v-if="child.type === 'button'"
                class="head-button-card_btn"
                :key="'c' + index"
                size="small"
                type="text"
                :disabled="child.disabled"
                @click="handleOperateChild(child.key)"
              >
                <i :class="child.icon" style="font-size:13px"></i>
                {{ child.title }}
              </el-button>
              <el-popover
                v-else
                :key="'c' + index"
                placement="bottom"
                v-model="child.visible"
                trigger="manual"
                width="350"
              >
                <div>
                  <el-form :model="form" :rules="rules" :ref="index + 'form'" size="small">
                    <el-row :gutter="10">
                    <template v-if="child.key === 'copy'">
                      <el-col :span="18">
                       <div class="form-item-title"> 每条计划单要复制几份？</div>
                        <el-form-item>
                          <el-input-number
                            v-model="form.copyNum"
                            @change="handleCopyChange"
                            :min="1"
                            :precision="0"
                            :step="1"
                            :max="10"
                            label="复制"
                            style="width:100%"
                          ></el-input-number>
                        </el-form-item>
                      </el-col>
                    </template>
                    <template v-if="child.key === 'callback'">
                      <el-col>
                        <el-form-item>
                          <div class="form-item-title">确定撤回已送审的计划？</div>
                        </el-form-item>
                      </el-col>
                    </template>
                    <!--优先级-->
                    <template v-if="child.key === 'editSeq'">
                      <el-col>
                        <div class="form-item-title">设置优先级</div>
                      </el-col>
                      <el-col :span="form.seqType === 1 ? 11 : 24">
                        <el-form-item>
                          <el-select
                            v-model="form.seqType"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in seqOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13" v-if="form.seqType === 1">
                        <el-form-item prop="seq">
                          <el-select v-model="form.seq" placeholder="请选择">
                            <el-option
                              v-for="item in seqListSource"
                              :key="item.dictValue"
                              :label="item.dictLabel"
                              :value="item.dictValue"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <div class="form-item-title"> 设置生效时间</div>
                      </el-col>
                      <el-col :span="form.seqTimeType === 2 ? 11 : 24">
                        <el-form-item>
                          <el-select
                            v-model="form.seqTimeType"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in timeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13" v-show="form.seqTimeType === 2">
                        <el-form-item prop="seqTime">
                          <el-date-picker
                            v-model="form.seqTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                            popper-class="form-time-picker_popper"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </template>
                    <!--投放速度-->
                    <template v-if="child.key === 'editSpeed'">
                      <el-col>
                          <div class="form-item-title">设置投放速度</div>
                      </el-col>
                      <el-col>
                        <el-form-item>
                        <el-select v-model="form.trafficSpeed">
                          <el-option
                            v-for="item in trafficOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col>
                          <div class="form-item-title">设置生效时间</div>
                      </el-col>
                      <el-col :span="form.trafficTimeType === 1 ? 24 : 11">
                        <el-form-item>
                          <el-select
                            v-model="form.trafficTimeType"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in timeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13" v-show="form.trafficTimeType === 2">
                        <el-form-item prop="trafficTime">
                          <el-date-picker
                            v-model="form.trafficTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                             popper-class="form-time-picker_popper"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </template>
                    <!--启用-->
                    <template v-if="child.key === 'start'">
                       <el-col>
                          <div class="form-item-title">设置生效时间</div>
                      </el-col>
                      <el-col :span="form.startTimeType === 1 ? 24 : 11">
                        <el-form-item>
                          <el-select
                            v-model="form.startTimeType"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in timeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13" v-show="form.startTimeType === 2">
                        <el-form-item prop="startTime">
                          <el-date-picker
                            v-model="form.startTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                            popper-class="form-time-picker_popper"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </template>
                    <!--暂停-->
                    <template v-if="child.key === 'pause'">
                       <el-col>
                          <div class="form-item-title">设置生效时间</div>
                      </el-col>
                      <el-col :span="form.pauseTimeType === 1 ? 24 : 11">
                        <el-form-item>
                          <el-select
                            v-model="form.pauseTimeType"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in timeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13" v-show="form.pauseTimeType === 2">
                        <el-form-item prop="pauseTime">
                          <el-date-picker
                            v-model="form.pauseTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                            popper-class="form-time-picker_popper"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </template>
                    <!--结束-->
                    <template v-if="child.key === 'end'">
                       <el-col>
                          <div class="form-item-title">设置生效时间</div>
                      </el-col>
                      <el-col :span="form.endTimeType === 1 ? 24 : 11">
                        <el-form-item>
                          <el-select
                            v-model="form.endTimeType"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in timeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="13" v-show="form.endTimeType === 2">
                        <el-form-item prop="endTime">
                          <el-date-picker
                            v-model="form.endTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                            popper-class="form-time-picker_popper"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </template>
                    <el-col>
                      <!-- <el-form-item> -->
                      <div style="text-align: right; margin: 0">
                        <el-button size="small" @click="handleCancel(child)"
                          >取消</el-button
                        >
                        <el-button
                          type="primary"
                          size="small"
                          @click="handleSave(child, index + 'form')"
                          >确定</el-button
                        >
                      </div>
                      <!-- </el-form-item> -->
                    </el-col>
                    </el-row>
                  </el-form>
                </div>
                <el-button
                  class="head-button-card_btn"
                  size="small"
                  type="text"
                  slot="reference"
                  style="margin: 0px 5px"
                  :disabled="child.disabled"
                  @click="handleChangePopover(child)"
                >
                  <i :class="child.icon" style="font-size:13px"></i>
                  {{ child.title }}</el-button
                >
              </el-popover>
              <el-divider
                v-if="child.key === 'callback'"
                :key="'c' + index"
                direction="vertical"
              ></el-divider>
            </template>
          </el-col>
          <el-col :span="2">
            <div style="text-align: end">
              <i
                style="font-size: 25px;padding-right:23px"
                class="el-icon-close"
                @click="showParentBtn = true"
              ></i>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    var checkSeqTime = (rule, value, callback) => {
      if (this.form.seqTimeType === 2) {
        if (value) {
          const curTime = new Date().getTime()
          const selectValue = value.getTime()
          if (selectValue > curTime) {
            callback()
          } else {
            callback(new Error('只能选择以后的时间'))
          }
        } else {
          callback(new Error('请选择生效时间'))
        }
      } else {
        callback()
      }
    }
    var checkTrafficTime = (rule, value, callback) => {
      if (this.form.trafficTimeType === 2) {
        if (value) {
          const curTime = new Date().getTime()
          const selectValue = value.getTime()
          if (selectValue > curTime) {
            callback()
          } else {
            callback(new Error('只能选择以后的时间'))
          }
        } else {
          callback(new Error('请选择生效时间'))
        }
      } else {
        callback()
      }
    }

    var checkSeq = (rule, value, callback) => {
      if (this.form.seqType === 1) {
        if (value) {
          callback()
        } else {
          callback(new Error('请选择优先级'))
        }
      } else {
        callback()
      }
    }
    var checkPauseTime = (rule, value, callback) => {
      if (this.form.pauseTimeType === 2) {
        if (value) {
          const curTime = new Date().getTime()
          const selectValue = value.getTime()
          if (selectValue > curTime) {
            callback()
          } else {
            callback(new Error('只能选择以后的时间'))
          }
        } else {
          callback(new Error('请选择生效时间'))
        }
      } else {
        callback()
      }
    }
    var checkEndTime = (rule, value, callback) => {
      if (this.form.endTimeType === 2) {
        if (value) {
          const curTime = new Date().getTime()
          const selectValue = value.getTime()
          if (selectValue > curTime) {
            callback()
          } else {
            callback(new Error('只能选择以后的时间'))
          }
        } else {
          callback(new Error('请选择生效时间'))
        }
      } else {
        callback()
      }
    }
    return {
      checkTableHeaderShow: [],
      clickType: undefined,
      showParentBtn: true,
      childrenBtnList: [],
      form: this.genForm(),
      rules: {
        seq: [{
          validator: checkSeq,
          trigger: 'change'
        }],
        seqTime: [
          {
            validator: checkSeqTime,
            trigger: 'blur'
          }
        ],
        trafficTime: [
          {
            validator: checkTrafficTime,
            trigger: 'blur'
          }
        ],
        pauseTime: [{ validator: checkPauseTime, trigger: 'blur' }],
        endTime: [{ validator: checkEndTime, trigger: 'blur' }]
      },
      seqOptions: [
        {
          label: '恢复默认优先级',
          value: 2
        },
        {
          label: '设置绝对优先级',
          value: 1
        }
      ],
      timeOptions: [
        {
          label: '定时生效',
          value: 2
        },
        {
          label: '立即生效',
          value: 1
        }
      ],
      trafficOptions: [
        {
          label: '匀速投放',
          value: 2
        },
        {
          label: '快速投放',
          value: 1
        },
        {
          label: '智能投放',
          value: 3
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      buttonListData: this.buttonList
    }
  },
  props: [
    'buttonObj',
    'isDisabled',
    'selected',
    'tagsData',
    'buttonList',
    'seqList'
  ],
  watch: {
    buttonObj() {
      this.buttonListData.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(e => {
            e.visible = false
          })
        }
      })
    },
    selected(newValue, oldValue) {
      if (newValue.length > 0 && this.buttonObj.fullTitle === '批量建单') {
        this.showParentBtn = false
        this.childrenBtnList = this.buttonList.filter(
          item => item.key === 'batchOperate'
        )[0].children
      }
    }
  },
  computed: {
    seqListSource() {
      return (this.seqList || []).filter(item => item.dictValue !== '0')
    }
  },
  methods: {
    genForm() {
      return {
        copyNum: 1,
        seqType: 1,
        seq: '',
        seqTimeType: 2,
        seqTime: '',
        trafficSpeed: 2,
        trafficTimeType: 2,
        trafficTime: '',
        startTimeType: 2,
        startTime: '',
        pauseTimeType: 2,
        pauseTime: '',
        endTimeType: 2,
        endTime: ''
      }
    },
    handleCreate() {
      this.$emit('create')
    },
    handleOperateParent(type) {
      this.clickType = type
      if (this.clickType === 'batchOperate') {
        this.showParentBtn = false
        this.childrenBtnList = this.buttonList.filter(
          item => item.key === type
        )[0].children
      } else {
        this.showParentBtn = true
        this.$emit('clickType', type)
      }
    },
    handleOperateChild(type) {
      this.$emit('clickType', type)
    },
    handleTagClose() {
      this.$emit('deleteTag', this.tagsData)
    },
    handleCopyChange() {},
    handleCancel(target) {
      const children = this.buttonListData[1].children
      const reslutIndex = children.findIndex(item => item.key === target.key)
      this.buttonListData[1].children[reslutIndex].visible = false
      this.form = this.genForm()
      this.$refs[reslutIndex + 'form'][0].resetFields()
    },
    handleSave(target, formName) {
      this.$refs[formName][0].validate(valid => {
        if (valid) {
          const children = this.buttonListData[1].children
          const reslutIndex = children.findIndex(
            item => item.key === target.key
          )
          this.buttonListData[1].children[reslutIndex].visible = false
          this.$emit('popover-save', this.form, target)
          this.form = this.genForm()
        }
      })
    },
    handleChangePopover(target) {
      if (target.visible) {
        this.buttonListData.forEach(item => {
          if (item.children && item.children.length > 0) {
            item.children.forEach(e => {
              e.visible = false
            })
          }
        })
      } else {
        this.buttonListData.forEach(item => {
          if (item.children && item.children.length > 0) {
            item.children.forEach(e => {
              e.visible = false
            })
          }
        })
        const reslutIndex = this.buttonListData[1].children.findIndex(
          item => item.key === target.key
        )
        this.$refs[reslutIndex + 'form'][0].resetFields()
        this.buttonListData[1].children[reslutIndex].visible = !target.visible
      }
    }
  },
  created() {}
}
</script>
<style lang="stylus" scoped>
.head-button
  margin 16px 0px
  display flex
  flex-direction row
  align-items center
.head-button button
  font-weight 400
.head-button-first
  font-size 12px
  background-color #FF8B00
  border 1px solid #ff8b00
  min-width 100px
  height 32px
  line-height 32px
  color #fff
  border-radius 4px
  cursor pointer
.head-button-first:hover
  background #ffa233
  border-color #ffa233
  color #FFF
.head-button-first span:first-child{
  padding 0 10px
  font-size 12px
}
.head-button-first span:last-child {
  padding-right 10px
}
.button-list
  display flex
  flex-direction row
.button-list  .el-button--text
  margin-left 30px
  padding  0
.grid-button
  width 100%
  display flex
  flex-direction row
  justify-content flex-end
.head-button-tag
  margin-left 30px
  // width 200px
.head-button-tag >>> .el-tag
  display flex
  border-radius 15px
.tag-text
  max-width: 226px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
.head-button-card,.head-button-card-disabled
  width 100%
  background-color #ff8b00
  padding  10px 0
  font-size 13px
.head-button-card,.head-button-card-disabled
  .el-row
    display flex
    flex-direction row
    align-items center
  .el-divider
    background-color #000
  .head-button-card_btn
    color #000
.head-button-card-disabled
    background-color rgba(250, 205, 145, 1)
    >>>.el-col-22
      opacity 0.5
>>>.el-select
  display block
>>>.el-date-editor.el-input, .el-date-editor.el-input__inner
  width 100%
.form-item-title
  padding-bottom 5px
.el-button.is-disabled.el-button--text
  color #888
</style>
